import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface States {
  tabIndex: number;
}

const initialState: States = {
  tabIndex: 0,
};

export const adminsEditAdminSlice = createSlice({
  initialState,
  name: 'adminsEditAdmin',
  reducers: {
    setTabIndex: (state, { payload }: PayloadAction<number>) => {
      state.tabIndex = payload;
    },
  },
});

export default adminsEditAdminSlice.reducer;

export const { setTabIndex: setTabIndexAction } = adminsEditAdminSlice.actions;
